import Layout from "@/components/common/Layout";
import TextField from "@/components/site-builder/TextField";
import { TextAlignment } from "@/constants/content";
import { SiteBuilderModuleTextFieldType } from "@/constants/site-builder";
import { ColorVariant, FontVariant } from "@/constants/theme";
import { useClientConfig } from "@/context/clientConfig";
import { createThemeColorObject } from "@/utils/theme/createThemeColorObject";
import type {
  BaseSiteBuilderModule,
  SiteBuilderModuleTextField,
} from "@/types/site-builder";
import s from "./RenderModuleError.module.scss";

export interface RenderModuleErrorProps {
  module: BaseSiteBuilderModule;
}

export default function RenderModuleError(props: RenderModuleErrorProps) {
  const { module } = props;
  const {
    env,
    siteConfig: { visualEditor },
  } = useClientConfig();

  if (env === "prod" || visualEditor) {
    return null;
  }

  const getTextField = (text: string): SiteBuilderModuleTextField => ({
    type: SiteBuilderModuleTextFieldType.Text,
    text,
    alignment: TextAlignment.Left,
    fontVariant: FontVariant.Default,
    color: createThemeColorObject(ColorVariant.Inherit),
  });

  return (
    <div className={s.wrapper}>
      <Layout containerOnly>
        <TextField
          type="text-small"
          field={getTextField("NOT VISIBLE ON PRODUCTION")}
        />
        <TextField
          type="header-h2"
          field={getTextField("Module render failed")}
        />
        <code>
          <ul>
            <li>{module.moduleType}</li>
            <li>{module["@type"]}</li>
            <li>{module.id}</li>
            <li>{module.baseContent?.name || "-"}</li>
          </ul>
        </code>
      </Layout>
    </div>
  );
}
